import React from 'react'
import { TableCellAgreementBudgetProps } from './TableCellAgreementBudget.types'
import styles from './TableCellAgreementBudget.module.scss'
// import cl from 'classnames'
import { Text1 } from '../Text1'
import { formatPrice } from 'utilities'
import { Agreement, AgreementDTO } from 'models'
import { WarningMessage } from 'components/common'

const TableCellAgreementBudgetComponent = (props: TableCellAgreementBudgetProps) => {
  const {
    data,
    notAvailableLabel = 'N/A'
  } = props

  if (!data) return null

  let agreement: Agreement = null

  if (!Array.isArray(data)) {
    agreement = data as Agreement
  } else if (data.length === 1) {
    agreement = data[0]
  }

  if (!agreement) return null

  const { budget, budgetRemaining } = agreement

  return (
    <div className={styles.container}>
      <Text1 bold>
        {
          budget === null
            ? <span className={styles.secondaryText}>{notAvailableLabel}</span>
            : (
              <>
                {formatPrice(budgetRemaining)}
                <span className={styles.secondaryText}> / {formatPrice(budget)}</span>
              </>
            )
        }
      </Text1>

      <WarningMessage
        object={data as AgreementDTO}
        objectType='agreement'
        agreementCol='remainingBudget'
      />
       <WarningMessage
        object={agreement as any as AgreementDTO}
        objectType='agreement'
        agreementCol='period'
      />
    </div>
  )
}

const TableCellAgreementBudget = TableCellAgreementBudgetComponent
export { TableCellAgreementBudget }
